import { nonNullable, values } from '@wix/wix-data-client-common-standalone'

export const applyModifiers = <Target>({
  target,
  modifiers,
}: {
  target: Target
  modifiers: { [Name in string]?: (target: Target) => Target }
}): Target =>
  values(modifiers)
    .filter(nonNullable)
    .reduce((target, modifier) => modifier(target), target)
